import { userService } from "../services/user.services";
import { setAuthItem, clearAuthSession, broadcastLogout } from "./authSession";

const refreshIdToken = async () => {
    
    const response = await userService.RefreshToken();
    if (response?.error === false && response?.data?.success_status === true) {
        setAuthItem('IdToken', response.data.data);
    } else {
        if(response?.message?.response?.status===400){
            // eslint-disable-next-line no-unused-vars
            const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
            setAuthItem('custom-status', 'inactive');
            clearAuthSession();
            broadcastLogout();
            localStorage.clear();
            if (browserIdValue) {
                localStorage.setItem('arcm_trust_browser_token', browserIdValue);
            }
            window.location.href = '/';
        }
    }
}

export default refreshIdToken;